import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class WaterBodyNavigationService {
  constructor(private router: Router) {}

  public nav(waterBodyVanity: string): void {
    let basePath = 'rental-location-map/';
    this.router.navigate(['/dummy'], { skipLocationChange: true }).then(() => {
      this.router.navigate([basePath + waterBodyVanity]);
    });
  }

  public navWithQueryParams(waterBodyVanity: string, queryParam: any): void {
    let basePath = 'rental-location-map/';
    this.router.navigate(['/dummy'], { skipLocationChange: true }).then(() => {
      this.router.navigate([basePath + waterBodyVanity], {
        queryParams: {
          queryParams: queryParam,
        },
      });
    });
  }
}
